import { DimensionStyle } from '../TextField/TextField.types';

export const setValidInputDimension = (width?: number, height?: number): DimensionStyle | undefined => {
  let inputStyle: DimensionStyle | undefined;
  if (typeof width === 'number' && width > 0) {
    inputStyle = {
      width: `${width}px`,
    };
  }
  if (typeof height === 'number' && height > 0) {
    inputStyle = inputStyle || {};
    inputStyle['height'] = `${height}px`;
  }
  return inputStyle;
};
